export function getStringWithVariables(
  text: string | undefined,
  variable: number | string | null | undefined,
  variableName: string
) {
  if (!variable || !text) {
    return '';
  }
  const regex = new RegExp(`\\$\\{${variableName}\\}`, 'g');
  return text.replace(regex, variable.toString());
}

export function getStringWithVariablesI18next(
  text: string | undefined,
  variable: number | string | null | undefined,
  variableName: string
) {
  if (!variable || !text) {
    return '';
  }
  const regex = new RegExp(`{{${variableName}}}`, 'g');
  return text.replace(regex, variable.toString());
}
